document.addEventListener('DOMContentLoaded', function () {
  const searchButton = document.querySelector('.home_search-button')
  if (searchButton) {
    searchButton.addEventListener('click', function () {
      const liman = document.querySelector('.home-searchbar__liman').value
      const tarih = document.querySelector('.home-searchbar__tarih').value
      const kisi = document.querySelector('.home-searchbar__kisi').value
      const arac = document
        .querySelector('.home-searchbar__arac')
        .value.toLowerCase()

      let baseUrl = ''

      if (arac === 'tekne') {
        baseUrl = '/tekneler/'
      } else if (arac === 'yat') {
        baseUrl = '/yatlar/'
      } else {
        return
      }

      const queryParams = new URLSearchParams({
        liman: liman,
        tarih: tarih,
        kisi: kisi,
      })

      window.location.href = baseUrl + '?' + queryParams.toString()
    })
  }
})
